import React, { Fragment } from 'react';
import { Button, Col, Form, message, Row } from 'antd';
import SupplierInformation from './components/SupplierInformation';
import AddressInformation from './components/AddressInformation';
import { useHistory } from 'react-router-dom';
import * as CommonService from '../../../services/CommonService';
import AdditionalInformation from './components/AdditionalInformation';
import { SUPPLIER } from '../../../services/endpoint';

const SupplierCreate = (props) => {

	const history = useHistory();
	const { onExit, callback } = props;

	// useEffect(() => {
	// 	setLoading(true);
	// 	CommonService.get('')
	// }, []);

	const handleSubmit = (e) => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				window.setLoading(true);
				const body = {
					...values,
					debt: {
						amount: values.totalDebt
					}
				};
				delete body.totalDebt;
				CommonService.create(SUPPLIER, body).then(res => {
					if (res.status === 200) {
						if (callback) {
							callback(res.data, props.form);
							return;
						}
						message.success('Tạo mới nhà cung cấp thành công');
						history.push('/supplier');
					}
				}).catch(err => message.error(err?.data?.message || 'Có lỗi xảy ra'))
					.finally(() => window.setLoading(false));
			}
		});
	};

	return (
		<Fragment>
			<Form layout={'vertical'}>
				<Row gutter={12}>
					<Col span={24}>
						<Row gutter={12}>
							<Col className={'mb-10'}>
								<SupplierInformation form={props.form} />
							</Col>
							<Col className={'mb-10'}>
								<AddressInformation form={props.form} />
							</Col>
						</Row>
					</Col>
					<Col span={24}>
						<AdditionalInformation form={props.form} />
					</Col>
				</Row>
				<Col style={{ textAlign: 'right', marginTop: 10 }}>
					<Button style={{ marginRight: '5px' }} type={'ghost'} onClick={() => onExit ? onExit(props.form) : history.push('/supplier')}>Thoát</Button>
					<Button type={'primary'} onClick={handleSubmit}>Tạo nhà cung cấp</Button>
				</Col>
			</Form>
		</Fragment>
	);
};
export default Form.create({ name: 'SupplierCreate' })(SupplierCreate);

